import { useEffect, useMemo } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import SecondaryPictureFreeCropper from './SecondaryPictureFreeCropper';

import './styles/PopupUpdateSecondaryPicture.css';

export default function PopupUpdateSecondaryPicture({
  open,
  image,
  exitCrop,
  setCroppedFile
}) {
  const t = useTranslations('common.forms.add_artwork');
  const imageUrl = useMemo(() => {
    if (!image) {
      return null;
    }

    if (typeof image === 'string') {
      return image;
    }

    return URL.createObjectURL(image);
  }, [image]);

  useEffect(() => {
    if (!imageUrl) {
      return undefined;
    }

    return () => {
      if (typeof image !== 'string') {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [image, imageUrl]);

  return (
    <GenericPopup
      open={open}
      className="secondary-picture-crop-popup crop-rect"
    >
      <div className="secondary-picture-crop__header">
        <p className="secondary-picture-crop__header-text">
          {t('media.secondary_picture')}
        </p>
        <p className="secondary-picture-crop__instructions">
          {t('media.crop_instruction')}
        </p>
      </div>

      {imageUrl && (
        <SecondaryPictureFreeCropper
          key={imageUrl}
          source={imageUrl}
          exitCrop={exitCrop}
          setCroppedFile={setCroppedFile}
        />
      )}
    </GenericPopup>
  );
}
